import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from "react";
import { useAuth } from "../hooks/useAuth";
// 创建认证上下文
const AuthContext = createContext(null);
/**
 * 认证提供者组件
 */
export const AuthProvider = ({ children }) => {
    const authState = useAuth();
    return (_jsx(AuthContext.Provider, { value: authState, children: children }));
};
// 认证上下文Hook
export const useAuthContext = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuthContext must be used within an AuthProvider");
    }
    return context;
};
export default AuthProvider;
